export const TERMINAL_BATCH_STATUSES: string[] = ['completed', 'failed', 'cancelled', 'partially_failed', 'pending_assignment', 'incomplete']
